import React, { useState, useEffect } from "react";
import { Form, Input, Upload, Button, message, Tag } from "antd";
import axiosInstance from "@/axios/axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";
import PdfViewer from "@/assets/PdfViewer.js";
import UploadAgreement from "@/components/UploadAgreement";
// import '@/styles/report.less';
import "./index.scss";

const PublishTutorial = () => {
  const navigate = useNavigate(); // 获取 navigate 函数
  const [form] = Form.useForm();
  const [editorData, setEditorData] = useState("");
  const [cover, setCover] = useState("");
  const [dataDetail, setDatali] = useState({});
  const [shiyTag, setshiycTag] = useState("1");
  const [fileList, setFileList] = useState([]);
  const [agreeToUpload, setAgreeToUpload] = useState(true); // 默认勾选

  let location = useLocation();
  let { state } = location;
  let itemId = state?.id;
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `paper/account/detail?paperId=${id}`
      );
      setDatali(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    if (itemId) {
      fetchDetails(itemId); // 如果itemId存在，
    } else {
      form.setFieldsValue({ tags: [{ key: "1", value: "AI绘画" }] });
    }
  }, [itemId]);

  useEffect(() => {
    // 当dataDetail更新时，更新表单的值
    if (Object.keys(dataDetail).length > 0) {
      form.setFieldsValue({
        ...dataDetail,
        content: dataDetail.contentUrl || "",
        tags: dataDetail.label || "",
      });
      setFileList([
        {
          uid: "-1",
          name: dataDetail.fileName,
          status: "done",
          url: dataDetail.contentUrl,
        },
      ]);
      setshiycTag(dataDetail.label + "");
      setEditorData(dataDetail.contentUrl);
    }
  }, [dataDetail, form]); // 依赖dataDetail和form，以便在它们变化时重新运行
  const onFinish = (values) => {
    if (!fileList.length) {
      message.warning("请上传文件！");
      return;
    }
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("originalAuthor", values.originalAuthor);
    formData.append("fileName", values.originalAuthor);
    formData.append("contentUrl", fileList.length && fileList[0].url);
    formData.append("label", shiyTag);
    let url = "paper/account/save";

    if (itemId) {
      formData.append("tutorialIdArray", itemId);
      url = "/paper/account/update";
    }
    try {
      axiosInstance
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "10000") {
            message.success("保存成功");
            navigate("/personal?selectedKey=3&openKeys=sub2&openKeys=sub1");
          } else {
            message.error("保存失败");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 }, // 在极小的屏幕上，label和wrapper都占据全部宽度
      sm: { span: 4 }, // 在稍大一些的屏幕上，label占据更少的宽度
    },
    wrapperCol: {
      xs: { span: 24 }, // 在极小的屏幕上，label和wrapper都占据全部宽度
      sm: { span: 18 }, // 在稍大一些的屏幕上，wrapper占据更多的宽度
    },
  };

  const onReset = () => {
    form.resetFields();
    navigate("/personal?selectedKey=3&openKeys=sub2&openKeys=sub1");
  };
  const handleTagClick = (tag) => {
    if (shiyTag !== tag.key) {
      setshiycTag(tag.key);
      form.setFieldsValue({ tags: [tag] });
    }
  };
  const shiyOptions = [
    { key: "1", value: "神经网络" },
    { key: "2", value: "自然语言理解 " },
    { key: "3", value: "强化学习" },
    { key: "4", value: "大模型" },
    { key: "5", value: "具身智能" },
  ].map((tag) => (
    <Tag
      color={shiyTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const handleChange = (info) => {
    let isLimit = info.fileList.length > 1;
    // 限制用户只能上传一个文件
    if (isLimit) {
      message.warning("You can only upload one file!");
    }

    // 上传成功
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
      // 这里可以添加解析和显示 PDF 的逻辑
      // 例如，你可以使用 pdf.js 来解析 PDF 文件
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }

    // 更新文件列表
    setFileList(info.fileList);
  };
  const handlePreview = (file) => {
    // 处理文件预览逻辑
  };
  const customUploadRequest = (options) => {
    const formData = new FormData();
    formData.append("file", options.file);
    // 添加其他字段或参数
    formData.append("type", 4);
    try {
      axiosInstance
        .post("/sys/image/file", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "10000") {
            setFileList([
              {
                uid: "-1",
                name: response.data.data.imageName,
                status: "done",
                url: response.data.data.imageUrl,
              },
            ]);
            // fetchUserInfo()
            // message.success('修改成功')
            // setDec('')
            // setWorkYears('')
          }
        })
        .catch((error) => {
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  let fileUrl = (fileList.length && fileList[0].url) || dataDetail.contentUrl;
  return (
    <Form
      form={form}
      {...formItemLayout}
      name="paper_form"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="标题"
        name="title"
        rules={[{ required: true, message: "请输入标题!" }]}
      >
        <Input showCount maxLength={60} />
      </Form.Item>

      <Form.Item
        label="原作者"
        name="originalAuthor"
        rules={[{ required: true, message: "请输入原作者!" }]}
      >
        <Input showCount />
      </Form.Item>
      <Form.Item
        name="content"
        label="内容"
        rules={[{ required: true, message: "请上传文件!" }]}
      >
        <Upload
          customRequest={customUploadRequest}
          // listType="picture-card"
          fileList={fileList}
          onChange={handleChange}
          onPreview={handlePreview}
        >
          {fileList.length < 1 && (
            <Button type="primary" style={{ marginRight: "40px" }}>
              上传PDF
            </Button>
          )}
        </Upload>
      </Form.Item>
      <Form.Item name="tagssx" label="预览">
        {/*<PdfViewer filePath={`${dataDetail.contentUrl}`} initialPage={1} scale={1} />*/}
        <PdfViewer
          filePath={`${
            fileUrl && fileUrl.split("/file/").length > 1
              ? "/file/" + fileUrl.split("/file/")[1]
              : ""
          }`}
          initialPage={1}
          scale={1}
        />
        {/*{<PdfViewer filePath={`/file/paper/17231949826463.pdf`} initialPage={1} scale={1} />}*/}
      </Form.Item>
      <Form.Item
        name="tags"
        label="教程标签"
        rules={[
          {
            required: true,
            message: "请选择至少一个标签",
          },
        ]}
      >
        {shiyOptions}
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <UploadAgreement checked={agreeToUpload} onChange={setAgreeToUpload} />
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: "40px" }}
        >
          提交
        </Button>
        <Button htmlType="button" onClick={onReset}>
          取消
        </Button>
      </Form.Item>
    </Form>
  );
};
export default PublishTutorial;
